import "./styles.css";
import React from "react";
import Tippy from "@tippyjs/react";
import _ from "lodash";

function EntirePropertySell(props) {
  let { selectedUnits = 0, propertyType, subRooms = [], features = [] } = props;

  const showUnits = selectedUnits > 1;

  let bedroomCount = 0;

  subRooms.forEach((room) => {
    bedroomCount += room.units;
  });

  return (
    <Tippy
      placement="bottom-start"
      arrow={true}
      interactive={true}
      content={<CustomTooltipContent subRooms={subRooms} />}
      offset={[8, 8]}
      className="entire-property-bedinfo-tooltip"
    >
      <div className="entire-property-info">
        <span className="entire-property-count">
          {showUnits && selectedUnits} Entire <div style={{ display: "inline" }}>{_.startCase(_.toLower(propertyType))}</div>
          {showUnits && "s"}
        </span>
        <ul>
          <li>
            <span className="entire-property-extra-details">{bedroomCount} bedrooms</span>
          </li>

          {features.map((feature, i) => {
            let { name, count } = feature;

            if (count > 1) name = name + "s";

            return (
              <li key={i}>
                <span className="entire-property-extra-details">
                  {count} {name}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </Tippy>
  );
}

export default EntirePropertySell;

const CustomTooltipContent = ({ subRooms = [] }) => {
  let accomodation_count = 0;

  return (
    <div className="entire-property-info-bed-pop">
      {subRooms.map((room, i) => {
        // map count of room units and double the retrun value
        return Array.from({ length: room.units }, (_, index) => index + 1).map((unit, index) => {
          accomodation_count++;
          return (
            <div key={index} style={{ display: "flex", alignItems: "center" }}>
              <div style={{ fontSize: "14px" }}>Accommodation {accomodation_count} :</div> &nbsp;&nbsp;
              <div
                style={{
                  fontSize: "12px",
                  position: "relative",
                  bottom: "-1px",
                }}
              >
                {room?.beds?.map((bed, i) => {
                  const bedType = bed.type.split(" /")[0];

                  return (
                    <React.Fragment key={i}>
                      {i !== 0 && " , "} {bed.quantity} &times; {bedType}
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          );
        });
      })}
    </div>
  );
};
